<div class="chips-bar">
  <app-chip
    *ngFor="let chip of chips"
    class="chips-bar__chip"
    [label]="chip.label"
    (onRemove)="chip.onRemove()"
    >
  </app-chip>
</div>
